import { abi } from './abi';
import { TRUSTED_NOTIFIER_MANAGER_CONTRACT_ADDRESS } from './constants';
export class TrustedNotifierManager {
    constructor(client, { address } = {}) {
        this.getLatestNotifierID = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getLatestNotifierID'
        });
        this.getNotifierForID = ({ id }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getNotifierForID',
            args: [id]
        });
        this.getNotifierForWallet = ({ address }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getNotifierForWallet',
            args: [address]
        });
        this.getNotifierForEndpoint = ({ endpoint }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getNotifierForEndpoint',
            args: [endpoint]
        });
        this.getNotifierForEmail = ({ email }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getNotifierForEmail',
            args: [email]
        });
        this.client = client;
        this.address = address ?? TRUSTED_NOTIFIER_MANAGER_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=trustedNotifierManager.js.map